import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapBreakingFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
    price: mapField("price", Number),
});

export const mapBreakingsFromServer = mapArray(mapBreakingFromServer);
